import { ID_KENO_FR } from '~/utils/constants/idsLotteries'
import { IDS_LOTTERIES_CLASSIC } from '~/utils/constants/home.js'

/**
 * Rebuilds a number-selection block (`first` or `last`) to match the required size
 * dictated by the lottery rules and play mode (single vs multiple bets).
 * Previously selected numbers are preserved up to the new limit; empty slots are `null`.
 * @param content.property      - Which block to update (`'first'` or `'last'`).
 * @param content.blockNumbers  - Mutable object containing the number arrays.
 * @param content.rules         - Lottery rules object.
 * @param content.ruleProperty  - Key inside `rules` for the relevant block (`'first_block'` / `'last_block'`).
 * @param content.mode          - Pass `null` to reset the block; anything else preserves existing picks.
 * @param content.multipleBets  - Whether the multiple-bets play mode is active.
 */
export const updateBlockNumbers = (content: any) => {
	const { property, blockNumbers, rules, ruleProperty, mode, multipleBets } = content as {
		property: string
		ruleProperty: string
		rules: any
		blockNumbers: any
		mode?: string | any
		multipleBets?: boolean
	}

	if (rules === null) return null
	if (blockNumbers === null) return null
	const rule = rules[ruleProperty]

	if (rule === null) {
		// Comportamiento original cuando no hay regla para ese value
		blockNumbers[property] = null
		return blockNumbers
	}

	const { id } = rules

	// Calcula el tamaño objetivo
	const size = ID_KENO_FR === id ? rule.min_select : rule.total || 1

	const sizeMultipleBets = property === 'first' ? rule.min_select + 1 || 1 : rule.min_select || 1
	const sizeByTypeLottery = IDS_LOTTERIES_CLASSIC.includes(id) ? rule.total : size
	const selectSize = multipleBets ? sizeMultipleBets : sizeByTypeLottery

	// Números previamente seleccionados (no nulos)
	const prev = Array.isArray(blockNumbers[property]) ? blockNumbers[property].filter((n) => n != null) : []

	// Construye el nuevo bloque según el modo
	if (mode === null) {
		blockNumbers[property] = Array(selectSize).fill(null)
		return blockNumbers
	}

	// 'selected': conserva previos hasta el límite y rellena con null
	const kept = prev.slice(0, selectSize)
	const padded = kept.concat(Array(Math.max(0, selectSize - kept.length)).fill(null))
	blockNumbers[property] = padded
	return blockNumbers
}
